export const handlesDefaultLabels = {
  V : "Ok",
  A : "Ignorado",
  R : "Falló",
  P : "Condición",
}